import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/wholesale-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Wholesale: Is It Worth It?</title>
        <meta
          name='description'
          content='This blog will cover everything you need to know about being a Poshmark wholesale vendor, what Poshmark wholesale means, and why you should want to be one.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/wholesale-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/wholesale-poshmark' />
        <meta property='og:title' content='Poshmark Wholesale: Is It Worth It?' />
        <meta
          property='og:description'
          content='This blog will cover everything you need to know about being a Poshmark wholesale vendor, what Poshmark wholesale means, and why you should want to be one.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
